var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fadescaleout",style:(_vm.getStyle)},[(typeof _vm.mode[0] == 'object')?[_c('gif',{attrs:{"mode":_vm.mode[0]}})]:_vm._e(),_c('span',{staticClass:"fadescaleout-title"},[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }